module.exports = __webpack_public_path__ + "static/media/bg-waterfall-mobile.5335795a.jpg";